import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { editMutations, editActions } from '@/modules/kartoteka/partner/store/types';
import { GDPR } from '@/modules/kartoteka/gdpr';
import { EditStoreProps } from '@/main/store/@types/edit.d';

import {
	dataType, NAME as name, DEPENDENT_TABLES as depTableNames,
	CRUMB_LABEL_KEY, MSG_LOG, DUPLICITY_CHECK, GDPR_LOG, CUSTOMER_HISTORY, CUSTOMER_FILES,
} from '../constants';
import { apiProvider } from '../api';
import { apiProvider as CDBapiProvider } from '../zakaznikCDB/api';

export const dropdownList = {
	VatId: [],
	KrukTitulId: [],
	TitulId: [],
	TitulZaId: [],
	StatId: [],
	ZakaznikSk: [],
	KategOzn: [],
	PlatbaPzn: [],
	EdiProviderId: [],
	ZakaznikVaria: [],
	CommunicationModes: [],
	CustomertypeId: [],
};

export const edit = {
	VatId: null as number | null,
	CisloOp: null as string | null,
	CisloOrient: null as number | null,
	CisloOrientPismeno: null as string | null,
	CisloPopisne: null as number | null,
	DdMailSendPrp: null as boolean | null,
	DicNr: null as string | null,
	DicPlatnePrp: null as boolean | null,
	DodavatelId: null as number | null,
	DodavatelPrp: null as boolean | null,
	DodavatelZkt: null as string | null,
	DopisOsl: null as string | null,
	DphPlatceNespPrp: null as boolean | null,
	DphPlatcePrp: null as boolean | null,
	EMailAdresa: null as boolean | null,
	EdiCode: null as string | null,
	EdiProviderId: null as number | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	FaxNr: null as string | null,
	FaxNrPozn: null as string | null,
	IcDphNr: null as string | null,
	IcoNr: null as string | null,
	IdDoklNr: null as string | null,
	IsOemApproval: null as boolean | null,
	IsForeignAmbassador: null as boolean | null,
	JinyplatceId: null as number | null,
	Jmeno: null as string | null,
	CustomerIdentifier: null as string | null,
	KategOzn: null as number | null,
	Kns: null as number | null,
	KontoNr: null as number | null,
	KrukTitulId: null as number | null,
	KrukamJmeno: null as string | null,
	KrukamPrijm: null as string | null,
	LeasfmaPrp: null as boolean | null,
	MatfirmId: null as number | null,
	Memo: null as string | null,
	MimoKusPrp: null as boolean | null,
	NarozeniDat: null as Date | null,
	WeddingAnniversary: null as Date | null,
	PhoneNo: null as string | null,
	Navstyden: null as string | null,
	NeplaticPrp: null as boolean | null,
	NorazakazId: null as number | null,
	Obec: null as string | null,
	ObecCast: null as string | null,
	ObjednavkaNr: null as string | null,
	Oddeleni: null as string | null,
	Oznam: null as string | null,
	PartnerStav: null as string | null,
	PersoncardId: null as string | null,
	PlatbaPzn: null as number | null,
	PojistovnaPrp: null as boolean | null,
	PracovnikId: null as number | null,
	PravniForma: null as string | null,
	PrevodMax: null as number | null,
	PscNr: null as string | null,
	SidloPrp: null as boolean | null,
	SplatnostInl: null as number | null,
	StatId: null as number | null,
	TelefonNr: null as string | null,
	TelefonNrPozn: null as string | null,
	TelexNr: null as string | null,
	TelexNrPozn: null as string | null,
	TelfmaNr: null as string | null,
	TelfmaNrPozn: null as string | null,
	TelmobNr: null as string | null,
	TelmobNrPozn: null as string | null,
	TelprivNr: null as string | null,
	TelprivNrPozn: null as string | null,
	Text: null as string | null,
	SearchString: null as string | null,
	VIN : null as string | null,
	LicensePlate : null as string | null,
	DbOperation: null as number | null,
	IsSearchInCDBFlag: null as boolean | null,
	TitulId: null as number | null,
	TitulZaId: null as number | null,
	Ulice: null as string | null,
	VstupDat: null as string | null,
	VstupPracId: null as number | null,
	VstupProvId: null as number | null,
	VyrazenDat: null as string | null,
	ZakaznikId: null as number | null,
	ZakaznikOsobniCis: null as string | null,
	ZakaznikSk: null as number | null,
	ZamestzarazeniId: null as string | null,
	ZkKartaNr: null as string | null,
	PartnertypPzn: 1 as number | null,
	ZodpovosobaId: null as number | null,
	EditPracIdText: null as string | null,
	JinyplatceIdText: null as string | null,
	MatfirmIdText: null as string | null,
	PracovnikIdText: null as string | null,
	PracovnikOsobniCis: null as string | null,
	VstupPracIdText: null as string | null,
	ZodpovosobaIdText: null as string | null,
	IsProdejce: null as boolean | null,
	PartnertypPznText: null as string | null,
	VecneKontoNrPermission: null as boolean | null,
	VstupProvIdText: null as string | null,
	ZakaznikkonId: null as number | null,
	CommunicationModeId: 0 as number | null,
	CdbSearchString: null as string | null,
	RelatedData: [],
	ZakaznikVariaList: [],
	UpdatedCustomerData: {
		RecordId: 0 as number | 0,
		ZakaznikId: null as number | null,
		TextOld: null as string | null,
		TextNew: null as string | null,
		JmenoOld: null as string | null,
		JmenoNew: null as string | null,
		TelmobNrOld: null as string | null,
		TelmobNrNew: null as string | null,
		OldEmailAddress: null as string | null,
		NewEmailAddress: null as boolean | null,
		UliceOld: null as string | null,
		UliceNew: null as string | null,
		ObecOld: null as string | null,
		ObecNew: null as string | null,
		PscNrOld: null as string | null,
		PscNrNew: null as string | null,
		StatIdOld: null as number | null,
		StatIdNew: null as number | null,
		VerifiedMode: null as string | null,
		VstupDat: null as null | Date,
		VstupPracId: null as number | null,
		EditDat: null as null | Date,
		EditPracId: null as number | null,
		ApprovedDat: null as null | Date,
		ApprovedPracId: null as number | null,
		VstupPracIdText: null as string | null,
		EditPracIdText: null as string | null,
		IsCustomerNameUpdated: false as boolean | false,
		IsCustomerEmailUpdated: false as boolean | false,
		IsCustomerMobileNumberUpdated: false as boolean | false,
		IsCustomerAddressUpdated: false as boolean | false,
		Remarks: null as string | null,
		IsActive: null as number | null,
		Pan: null as string | null,
		Gstin: null as string | null,
		StatNameOld: null as string | null,
		StatNameNew: null as string | null,
		DealershipDetails: null as string | null,
		SearchString: null as string | null,
		GoldenAccountId: null as string | null,
	},
	isTextchanged: false,
	Pan: null as string | null,
	GSTIN: null as string | null,
	CustomertypeId: null as number | null,
	isEmailChanged: false,
	SezWithGst: null as boolean | null,
	IsSez: null as boolean | null,
	SezWithoutGst: null as boolean | null,
	GoldenAccountId: null as string | null,
	CustomerInsertSource: null as string | null,
	ContactDetails:[] as any[] | null	
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames,
	depTableSettings: {
		[GDPR.name]: {
			loadByEntityId: true,
			filter(state) { return { ZakaznikId: state.props.id }; },
		},
		[GDPR_LOG]: {
			loadByEntityId: true,
			filter(state) { return { ZakaznikId: state.props.id }; },
		},
		[CUSTOMER_HISTORY]: {
			loadByEntityId: true,
			filter(state) { return { ZakaznikId: state.props.id }; },
		},
		[MSG_LOG]: {
			loadByEntityId: true,
			filter(state) { return { ZakaznikId: state.props.id }; },
		},
		[CUSTOMER_FILES]: {
			loadByEntityId: true,
			filter(state) { return { ZakaznikId: state.props.id }; },
		},
		[DUPLICITY_CHECK]: {
			filter(state) {
				return {
					Jmeno: state.edit.Jmeno,
					Text: state.edit.Text,
					Ulice: state.edit.Ulice,
					Obec: state.edit.Obec,
					IcoNr: state.edit.IcoNr,
					DicNr: state.edit.DicNr,
					TelprivNr: state.edit.TelprivNr,
					TelfmaNr: state.edit.TelfmaNr,
					TelmobNr: state.edit.TelmobNr,
					EMailAdresa: state.edit.EMailAdresa,
					Kns: state.edit.Kns,
					ZakaznikId: state.edit.ZakaznikId,
				};
			},
		},
	},
	localState: {
		isFromMerge: null as boolean | null,
	},
	extraActions: {
		async [editActions.SET_CDB_ZAKAZNIK]({ commit }, data) {
			const resp = await CDBapiProvider.entity(data.cdbZakaznikId);
			commit(editMutations.MAP_CDB_ZAKAZNIK, { data: resp.data });
		},
	},
	extraGetters: {},
	extraMutations: {
		[editMutations.SET_ARES_DATA](state, data) {
			data.forEach((row: { name: string, dataType: number, value: any }) => {
				const storeName = row.name.charAt(0).toUpperCase() + row.name.slice(1);
				const index = Object.keys(state.edit).indexOf(storeName);
				if (index !== -1) {
					if (row.dataType === dataType.date) {
						(state.edit as any)[storeName] = new Date(row.value);
					} else {
						(state.edit as any)[storeName] = row.value;
					}
				} else {
					console.error(`store not contains value: ${storeName}`);
				}
			});
		},
		[editMutations.PARTNER_JINY_PLATCE_SELECT_MAPPER](state, { data }) {
			state.edit.JinyplatceId = data.value;
			state.edit.JinyplatceIdText = data.text;
		},
		[editMutations.PARTNER_MAT_FIRM_SELECT_MAPPER](state, { data }) {
			state.edit.MatfirmId = data.value;
			state.edit.MatfirmIdText = data.text;
		},
		[editMutations.PARTNER_PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.PracovnikId = data.value;
			state.edit.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.PracovnikOsobniCis = data.osobniCis;
		},
		[editMutations.PARTNER_KONTAKT_MERGE_DATA](state, data) {
			state.localState.isFromMerge = true;
			Object.keys(data).forEach((key) => {
				if (data[key]) {
					if (key === 'StatId') {
						state.edit[key] = Number(data[key]); // TP1-TODO: bug na pretypovani na BE
					} else {
						(state.edit as any)[key] = data[key];
					}
				}
			});
		},
		[editMutations.MAP_CDB_ZAKAZNIK](state, { data }) {

			state.edit.Jmeno = data.Jmeno;
			state.edit.Text = data.Text;
			state.edit.TitulId = data.TitulPred;
			state.edit.TitulZaId = data.TitulZa;
			state.edit.NarozeniDat = data.NarozeniDat;
			state.edit.WeddingAnniversary = data.WeddingAnniversary;
			state.edit.PhoneNo = data.PhoneNo;
			state.edit.IcoNr = data.IcoNr;
			state.edit.DicNr = data.DicNr;
			state.edit.Ulice = data.Ulice;
			state.edit.Obec = data.Obec;
			state.edit.PscNr = data.PscNr;
			state.edit.StatId = data.StatText;
			state.edit.TelfmaNr = data.TelfmaNr;
			state.edit.TelprivNr = data.TelprivNr;
			state.edit.FaxNr = data.FaxNr;
			state.edit.TelmobNr = data.TelmobNr;
			state.edit.EMailAdresa = data.EmailAdresa;
			state.edit.ZkKartaNr = data.Pan;
			state.edit.KategOzn = data.KategOzn;
		},
	},
	props: {
		id: null as any |null,
		mode: null,
		goldenAccountId: null as string | null,
		customerInsertSource: null as string | null,
		salutation: null as string | null,
		name: null as string | null,
		dmsPhone: null as string | null,
		dmsMobile: null as string | null,
		dmsEmail: null as any | null,
		vin: null as string | null,
		accountRecordType: null as string | null,
		dmsFax: null as string | null,
		goldenAssetName: null as string | null,
		billingStreet: null as string | null,
		postalCode: null as string | null,
		billingCity: null as string | null,
		billingCountry: null as string | null,
		dmsDescription2: null as string | null,
		birthDate: null as Date | null,
		insuranceType: null as string | null,
		insurance: null as string | null,
		gender: null as string | null,
		contactDetails: [] as any[] | null,
		goldenAccountLastModified: null as Date | null,
	},
});
